<script setup lang="ts">
import {computed} from 'vue';
import AppMenu from './AppMenu.vue';
import AppMenuClassico from './AppMenuClassico.vue';
import {useMenuVersao} from '@/layout/composables/useMenuVersao';

const {versao, definirVersao} = useMenuVersao();

const versaoNova = computed<boolean>({
    get: () => versao.value === 'novo',
    set: (ativa) => definirVersao(ativa ? 'novo' : 'classico')
});
</script>

<template>
    <div class="layout-sidebar">
        <div class="menu-versao">
            <span class="menu-versao__titulo">
                <i class="pi pi-sliders-h"></i>
                Versão do menu
            </span>
            <div class="menu-versao__switch">
                <span :class="{'menu-versao__opcao--ativa': !versaoNova}">Clássico</span>
                <ToggleSwitch v-model="versaoNova" aria-label="Versão do menu" />
                <span :class="{'menu-versao__opcao--ativa': versaoNova}">Novo</span>
            </div>
        </div>
        <app-menu v-if="versao === 'novo'"></app-menu>
        <app-menu-classico v-else></app-menu-classico>
    </div>
</template>

<style lang="scss" scoped>
.menu-versao {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-bottom: 1rem;

    &__titulo {
        display: flex;
        align-items: center;
        gap: 0.4rem;
        font-size: 0.72rem;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.02em;
        color: var(--text-color-secondary);
    }

    &__switch {
        display: flex;
        align-items: center;
        gap: 0.6rem;
        font-size: 0.85rem;
        color: var(--text-color-secondary);
    }

    &__opcao--ativa {
        color: var(--text-color);
        font-weight: 600;
    }
}
</style>
